/* ============================================================
   Cart Cross-Sell — Quick-Add (Spitzbub)
   Adds single-variant products via /cart/add.js.
   Multi-variant products open the Quick-Add Drawer (qa-trigger).
   ============================================================ */

(function () {
  'use strict';

  function getContainer() {
    return document.querySelector('[data-cart-cross-sell]');
  }

  function handleAdd(btn) {
    if (btn.classList.contains('cdu-cross-sell__add--loading')) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('cdu-cross-sell__add--loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add failed');
        return res.json();
      })
      .then(function () {
        btn.classList.remove('cdu-cross-sell__add--loading');
        btn.classList.add('cdu-cross-sell__add--done');
        btn.textContent = '\u2713 Hinzugef\u00FCgt';

        setTimeout(function () {
          btn.classList.remove('cdu-cross-sell__add--done');
          btn.textContent = '+ Hinzuf\u00FCgen';
        }, 2000);

        var cartItems = document.querySelector('cart-drawer-items');
        if (cartItems && typeof cartItems.onCartUpdate === 'function') {
          cartItems.onCartUpdate();
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          fetch('/cart.js')
            .then(function (r) { if (!r.ok) throw new Error(r.statusText); return r.json(); })
            .then(function (cartData) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'cart-cross-sell',
                cartData: cartData
              });
            })
            .catch(function (e) { console.error('[cart-cross-sell] cart.js fetch error:', e); });
        }
      })
      .catch(function () {
        btn.classList.remove('cdu-cross-sell__add--loading');
        btn.textContent = 'Fehler';
        setTimeout(function () { btn.textContent = '+ Hinzuf\u00FCgen'; }, 1500);
      });
  }

  function bind() {
    var container = getContainer();
    if (!container || container.dataset.csBound) return;
    container.dataset.csBound = '1';

    container.addEventListener('click', function (e) {
      var btn = e.target.closest('.cdu-cross-sell__add');
      if (btn && !btn.classList.contains('qa-trigger')) {
        e.preventDefault();
        handleAdd(btn);
      }
    });
  }

  function rebind() {
    var container = getContainer();
    if (container) delete container.dataset.csBound;
    bind();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
      if (evt && evt.source === 'cart-cross-sell') return;
      setTimeout(rebind, 250);
    });
  }

  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    new MutationObserver(function () {
      var container = getContainer();
      if (container && !container.dataset.csBound) bind();
    }).observe(drawer, { childList: true, subtree: true });
  }
})();
